import React, { useState } from "react";
import TaskForm from "./TaskForm";

function CreateTask() {
    // use to determine whether the task detail is reveal or hidden
    const [modalOpenTaskForm, setModalOpenTaskForm] = useState(false);

    // reveal the task detail
    const openModalTaskForm = () => {
        setModalOpenTaskForm(true);
    };

    // make the task detail hidden
    const closeModalTaskForm = () => {
        setModalOpenTaskForm(false);
    };

    return (
        <div>
            <button
                type="button"
                // create button
                className="inline-block align-middle text-center select-none font-normal whitespace-no-wrap leading-normal no-underline text-white hover:bg-gray-800 bg-gray-700 font-sans mx-2.5 my-0 px-[20px] py-[5px] rounded-[20px]"
                onClick={openModalTaskForm}
            >
                CREATE <i className="fa-solid fa-plus"></i>
            </button>
            {modalOpenTaskForm === true && <TaskForm closeModal={closeModalTaskForm} />}
        </div>
    );
}

export default CreateTask;
